import React, { useEffect, useRef, useState } from "react";

const FileUpload = ({
  filedata,
  setAttachmark,
  setAttchsubject,
  onRemoveFile,
  onAddFiles,
}) => {
  const marks = {
    GS: ["10", "15"],
    Ethics: ["10", "20"],
    Essay: ["125"],
    Optional: ["10", "15", "20"]
  };

  const firstSubject = Object.keys(marks)[0];
  const firstMark = marks[firstSubject][0];

  const [selectedSubject, setSelectedSubject] = useState(firstSubject);
  const [selectedMarks, setSelectedMarks] = useState(firstMark);

  const files = Array.isArray(filedata)
    ? filedata
    : filedata
    ? [filedata]
    : [];

  // Sync selected subject & marks with parent
  useEffect(() => {
    setAttachmark(selectedMarks);
    setAttchsubject(selectedSubject);
  }, [selectedSubject, selectedMarks, setAttachmark, setAttchsubject]);

  const addInputRef = useRef(null);

  const handleAddClick = () => {
    addInputRef.current && addInputRef.current.click();
  };

  const handleAddChange = (e) => {
    if (onAddFiles) {
      onAddFiles(e.target.files);
    }
    e.target.value = "";
  };

  const selectSubject = (subject) => {
    setSelectedSubject(subject);
    setSelectedMarks(marks[subject][0]); // reset marks when changing subject
  };

  const selectMarks = (mark) => {
    setSelectedMarks(mark);
  };

  return (
    <div className="MYcontainer cust-border">
      <div className="fileuploader-container">
        {/* FILE UPLOAD BOX */}
        <div className="file-container" style={{ textAlign: "center" }}>
          <div className="file-upload" id="file-upload-div">
            <input
              type="file"
              ref={addInputRef}
              style={{ display: "none" }}
              multiple
              accept=".pdf,.docx,.jpg,.jpeg,.png,.gif,.bmp,.tiff,.webp,.heic,.heif,.ico,.avif"
              onChange={handleAddChange}
            />

            {files.length > 0 ? (
              <div className="upload-file-list-mini">
                {files.map((f, index) => {
                  const fileObj = f?.file || f;
                  return (
                    <div className="upload-file-item-mini" key={f?.id ?? index}>
                      <img
                        src="/assets/images/mingcute_pdf-fill.svg"
                        alt="file-icon"
                      />
                      <span
                        className="upload-file-name"
                        style={{ textAlign: "left" }}
                        title={fileObj?.name}
                      >
                        {fileObj?.name}
                      </span>
                      {onRemoveFile && (
                        <span
                          className="upload-file-remove"
                          onClick={(e) => {
                            e.stopPropagation();
                            onRemoveFile(f.id);
                          }}
                        >
                          <img
                            src="/assets/images/close-icon-file-box.svg"
                            alt="remove"
                            width={14}
                            height={14}
                          />
                        </span>
                      )}
                    </div>
                  );
                })}
                {onAddFiles && (
                  <div
                    className="upload-file-item-mini upload-file-add-more"
                    onClick={handleAddClick}
                  >
                    <img
                      src="/assets/images/attach.svg"
                      alt=""
                      width={14}
                      height={14}
                    />
                    <span className="upload-file-add-text">Add more</span>
                  </div>
                )}
              </div>
            ) : (
              <div
                className="upload-file-item-mini upload-file-add-more"
                onClick={handleAddClick}
              >
                <img
                  src="/assets/images/attach.svg"
                  alt=""
                  width={14}
                  height={14}
                />
                <span className="upload-file-add-text">Add more</span>
              </div>
            )}
          </div>
        </div>

        {/* SUBJECT SELECT */}
        <div className="options-container-fileupload">
          <div className="subject-select">
            <p className="select-text-file" style={{ color: "#9698B0" }}>
              Paper
            </p>

            <div className="text-options-box">
              {Object.keys(marks).map((subject) => (
                <button
                  key={subject}
                  className={`subject-btn ${
                    selectedSubject === subject ? "active selected-clr" : ""
                  }`}
                  onClick={() => selectSubject(subject)}
                >
                  {subject}
                </button>
              ))}
            </div>
          </div>

          {/* MARKS SELECT */}
          <div className="marks-select" style={{ marginTop: "10px" }}>
            <p className="select-text-file" style={{ color: "#9698B0" }}>
              Marks
            </p>

            <div className="text-options-box">
              {marks[selectedSubject].map((mark) => (
                <button
                  key={mark}
                  className={`marks-btn ${
                    selectedMarks === mark ? "active selected-clr" : ""
                  }`}
                  onClick={() => selectMarks(mark)}
                >
                  {mark}
                </button>
              ))}
            </div>
          </div>

          {/* Hidden inputs */}
          <input type="hidden" value={selectedSubject} />
          <input type="hidden" value={selectedMarks} />
        </div>
      </div>
    </div>
  );
};

export default FileUpload;